// React-imports
import { ReactElement, useEffect, useState } from "react";

// Style Imports
import "./reset-password.scss";

const ResetPassword: React.FC = (): ReactElement => {
  const [device, setDevice] = useState<string>("");

  useEffect(() => {
    if (navigator.userAgent.toLowerCase().includes("android")) {
      setDevice("android");
    } else if (/(iPad|iPhone|iPod)/.test(navigator.userAgent)) {
      setDevice("ios");
    } else {
      setDevice("pc");
    }
  }, []);

  return (
    <div className="flex flex-col reset-password items-center min-h-screen">
      <div className="background"></div>
      <img src="./images/kamco-logo.png" alt="kamco invest" />
      <div className="white-container">
        <table>
          <tr>
            <td>
              <img
                src="./images/verified.svg"
                alt="kamco registeration-image"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span>Password Reset Request</span>
            </td>
          </tr>
        </table>
        <span className="border"></span>
        <p className="first-p">
          Your password reset request has been verified. If you initiated the
          reset through the portal, please return there to set your new
          password.
        </p>
        <p>
          If you're using the Kamco app, open it to complete the password reset.
          Need help? Our{" "}
          <a
            href="
            mailto:support@kamcoinvest.com
          "
            className=" font-semibold underline text-[#034797]"
          >
            support
          </a>{" "}
          team is here to assist you.
        </p>
        {/* {device !== "pc" && (
          <a
            href={
              device === "android"
                ? "intent://scan/#Intent;scheme=zxing;package=com.kamco.stage.android;end"
                : "kamcoInvest://"
            }
            className="button text-sm md:text-base w-full"
          >
            Back to mobile application
          </a>
        )} */}
      </div>
      <footer className=" flex flex-col mt-auto">
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/kamco-invest/"
            >
              <img src="./images/linkedin.svg" alt="kamco invest linkedin" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/kamcoinvest"
            >
              <img src="./images/facebook.svg" alt="kamco invest facebook" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/KamcoInvest"
            >
              <img src="./images/twitter.svg" alt="kamco twitter x" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/kamco_invest/?hl=en"
            >
              <img src="./images/instagram.svg" alt="kamco instagram" />
            </a>
          </li>
        </ul>
        <p className="text-sm md:text-base">
          Copyright © 2024 Kamco Invest. All Rights Reserved
        </p>
      </footer>
    </div>
  );
};

export default ResetPassword;
